import { serviceMaker } from "..";
import { IActiveInactive, IPagination } from "../../data/AppInterface";
import { TBitValue } from "../../data/AppType";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";
import { BIT_VALUE } from "../../utils/AppEnumerations";

export interface IClaimGroupPayload {
  id?: string;
  claim_group_name: string;
  claims: string[];
  is_active: TBitValue;
}

export const GET_ALL_CLAIM_GROUP = (activeInactiveValue?: string) =>
  serviceMaker(
    API_ENDPOINTS.get_all_claim_group.url +
      `?noPagination=${BIT_VALUE.One}${
        activeInactiveValue ? `&active=${activeInactiveValue}` : ""
      }`,
    API_ENDPOINTS.get_all_claim_group.method
  );

export const ACTIVE_INACTIVE_CLAIM_GROUP = async (
  id: string,
  activeInactiveValue: IActiveInactive
) => {
  return serviceMaker(
    API_ENDPOINTS.active_inactive_claim_group.url + `/${id}`,
    API_ENDPOINTS.active_inactive_claim_group.method,
    activeInactiveValue
  );
};

export const DELETE_CLAIM_GROUP = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.delete_claim_group.url + `/${id}`,
    API_ENDPOINTS.delete_claim_group.method
  );
};
export const GET_CLAIM_GROUP_BY_ID = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.get_all_claim_group.url + `/${id}`,
    API_ENDPOINTS.get_all_claim_group.method
  );
};

export const CREATE_CLAIM_GROUP = (payload: IClaimGroupPayload) => {
  return serviceMaker(
    API_ENDPOINTS.create_claim_group.url,
    API_ENDPOINTS.create_claim_group.method,
    payload
  );
};

export const UPDATE_CLAIM_GROUP = (payload: IClaimGroupPayload, id: string) => {
  return serviceMaker(
    API_ENDPOINTS.update_claim_group.url + `/${id}`,
    API_ENDPOINTS.update_claim_group.method,
    payload
  );
};

// roles
export interface IRolesPayload {
  id?: string;
  role_name: string;
  claims: string[];
  is_active: TBitValue;
}

export const GET_ALL_ROLES = (pagination: IPagination, search: string) =>
  serviceMaker(
    API_ENDPOINTS.get_all_roles.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }`,
    API_ENDPOINTS.get_all_roles.method
  );

export const GET_ROLE_BY_ID = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.get_all_roles.url + `/${id}`,
    API_ENDPOINTS.get_all_roles.method
  );
};

export const CREATE_ROLE = (payload: IRolesPayload) => {
  return serviceMaker(
    API_ENDPOINTS.create_role.url,
    API_ENDPOINTS.create_role.method,
    payload
  );
};

export const DELETE_ROLE = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.delete_role.url + `/${id}`,
    API_ENDPOINTS.delete_role.method
  );
};

export const ACTIVE_INACTIVE_ROLE = async (
  id: string,
  activeInactiveValue: IActiveInactive
) => {
  return serviceMaker(
    API_ENDPOINTS.active_inactive_role.url + `/${id}`,
    API_ENDPOINTS.active_inactive_role.method,
    activeInactiveValue
  );
};

export const UPDATE_ROLE = (payload: IRolesPayload, id: string) => {
  return serviceMaker(
    API_ENDPOINTS.update_role.url + `/${id}`,
    API_ENDPOINTS.update_role.method,
    payload
  );
};
